// Freezes still objects once the scene settles.
import { scene } from '../core/scene.js';
import { dynamicRoots } from '../core/optimise.js';

export let settleStatics;

export function buildSettle() {
  settleStatics = function settleStatics(freeze) {
    for (const c of scene.children) {
      if (dynamicRoots.has(c) || c.isLight || !c.matrixWorldAutoUpdate) continue;
      if (!freeze) {
        settleSnap.set(c, poseSum(c));
        continue;
      }
      if (settleSnap.has(c) && settleSnap.get(c) === poseSum(c)) {
        c.updateMatrixWorld(true);
        c.matrixWorldAutoUpdate = false;
      }
    }
  };

  // Thousands of still objects (furniture, sitters, parked things) were re-composing their world matrices every frame.
  // Snapshot every top-level object's transforms, look again 90 frames later, and stop auto-updating those that didn't move.
  // Lights and anything the player can set in motion (dynamicRoots) are never frozen.
  const settleSnap = new Map();
  const poseSum = (o) => {
    let s = 0,
      k = 1;
    o.traverse((n) => {
      for (const v of [
        n.position.x,
        n.position.y,
        n.position.z,
        n.quaternion.x,
        n.quaternion.y,
        n.quaternion.z,
        n.scale.x,
      ])
        s += v * (k = k * 1.0001 + 1);
    });
    return s;
  };
}
